var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/hotels/formatting.ts
import { createIntl as createIntl2, createIntlCache as createIntlCache2 } from "@formatjs/intl";
import { parseISO } from "date-fns";
import { format as format2 } from "date-fns-tz";

// src/constants.ts
var DEFAULT_PARAGRAPH_SEPARATOR = "<br></br>";

// src/hotels/utils/index.ts
import { createIntl, createIntlCache } from "@formatjs/intl";
import { format, isValid } from "date-fns";

// src/hotels/getHotelPolicies.ts
function getHotelPolicies(packageRules, options) {
  const locale = (options == null ? void 0 : options.locale) || "en";
  const dateFormat = (options == null ? void 0 : options.dateFormat) || CANCELLATION_DATE_TIME_FORMAT;
  const now = /* @__PURE__ */ new Date();
  const refundable = { label: "Refundable", penalties: [] };
  const partiallyRefundable = {
    label: "Partially refundable",
    penalties: []
  };
  const nonRefundable = { label: "Non-Refundable", penalties: [] };
  let firstPenaltyStartDate = null;
  let latestEndDate = null;
  let futurePenaltyDate = null;
  const getFormattedDates = (rule) => {
    var _a, _b;
    const startDateTime = (_a = rule == null ? void 0 : rule.startDateTime) == null ? void 0 : _a.formattedDateTime;
    const endDateTime = (_b = rule == null ? void 0 : rule.endDateTime) == null ? void 0 : _b.formattedDateTime;
    return {
      startDateTime,
      endDateTime,
      formattedStartDateTime: startDateTime ? formatDateTime(
        startDateTime,
        dateFormat,
        locale,
        options == null ? void 0 : options.shouldUseLocalTime
      ) : null,
      formattedEndDateTime: endDateTime ? formatDateTime(
        endDateTime,
        dateFormat,
        locale,
        options == null ? void 0 : options.shouldUseLocalTime
      ) : null
    };
  };
  const getPenaltyAmount = (rule) => {
    var _a;
    if ((_a = rule.feeAmount) == null ? void 0 : _a.amount)
      return `${rule.feeAmount.amount} ${rule.feeAmount.currency}`;
    if (rule.chargeableUnit)
      return `${rule.chargeableUnit} night${rule.chargeableUnit > 1 ? "s" : ""}`;
    return rule.percent ? `${rule.percent}%` : void 0;
  };
  const updateImportantDates = (startDateTime, endDateTime) => {
    firstPenaltyStartDate = !firstPenaltyStartDate || startDateTime < firstPenaltyStartDate ? startDateTime : firstPenaltyStartDate;
    latestEndDate = !latestEndDate || endDateTime > latestEndDate ? endDateTime : latestEndDate;
    if (new Date(startDateTime) > now) futurePenaltyDate = startDateTime;
  };
  function finalizeNonRefundablePolicy() {
    if (latestEndDate && new Date(latestEndDate) < now) {
      const formattedLastPenaltyStartDate = formatDateTime(
        latestEndDate,
        dateFormat,
        locale,
        options == null ? void 0 : options.shouldUseLocalTime
      );
      nonRefundable.penalties.push({
        id: "noRefundAfterDate",
        endDateString: formattedLastPenaltyStartDate
      });
    }
  }
  function finalizeRefundablePolicy() {
    if (firstPenaltyStartDate && new Date(firstPenaltyStartDate) > now) {
      const formattedFirstPenaltyStartDate = formatDateTime(
        firstPenaltyStartDate,
        dateFormat,
        locale,
        options == null ? void 0 : options.shouldUseLocalTime
      );
      refundable.penalties.push({
        id: "fullyRefundableBefore",
        startDateString: formattedFirstPenaltyStartDate,
        hasPenaltyInFuture: !!futurePenaltyDate
      });
    }
  }
  const processNonRefundable = (rule, penalty) => {
    var _a, _b;
    if (rule.packageType === "conditionalCancel") {
      const dates = getListOfDatesFromInterval({
        startDate: (_a = rule.startDateTime) == null ? void 0 : _a.formattedDateTime,
        endDate: (_b = rule.endDateTime) == null ? void 0 : _b.formattedDateTime,
        locale: options == null ? void 0 : options.locale
      });
      nonRefundable.penalties.push({
        dates,
        id: "conditionalNonRefundable"
      });
    } else if (penalty.startDateString) {
      nonRefundable.penalties.push({
        endDateString: penalty.startDateString,
        id: "noRefundAfterDate"
      });
    } else {
      nonRefundable.penalties.push({ id: "duringStayCancellation" });
    }
  };
  for (const rule of packageRules) {
    const {
      startDateTime,
      endDateTime,
      formattedStartDateTime,
      formattedEndDateTime
    } = getFormattedDates(rule);
    if (!startDateTime || !endDateTime || new Date(endDateTime) < now) continue;
    const penaltyAmount = getPenaltyAmount(rule);
    updateImportantDates(startDateTime, endDateTime);
    const penalty = {
      startDateString: formattedStartDateTime || "",
      endDateString: formattedEndDateTime || "",
      penaltyAmount
    };
    if (rule.packageType === "cancel" && rule.ruleTypeInd === true && (new Date(startDateTime) > now || new Date(startDateTime) <= now && now <= new Date(endDateTime))) {
      if (penaltyAmount)
        partiallyRefundable.penalties.push(__spreadProps(__spreadValues({}, penalty), { id: "partialPenalty" }));
    } else if (rule.ruleTypeInd === false) {
      processNonRefundable(rule, penalty);
    }
  }
  finalizeRefundablePolicy();
  finalizeNonRefundablePolicy();
  return [refundable, partiallyRefundable, nonRefundable].filter(
    (policy) => policy.penalties.length > 0
  );
}

// src/hotels/utils/index.ts
import * as Locales from "date-fns/locale";
var DATE_FORMAT = "do MMMM yyyy";
var getIsRefundable = (packageRules) => {
  const policies = getHotelPolicies(packageRules, {
    currency: "",
    locale: ""
  });
  return !!policies.find(
    (item) => item.label === "Refundable" || item.label === "Partially refundable"
  );
};
var intlCache = createIntlCache();
var getCancellationTypeLabel = (packageRules, locale, dateFormat) => {
  const policies = getHotelPolicies(packageRules, {
    locale,
    dateFormat,
    currency: ""
  });
  const message = () => {
    const refundableItem = policies.find((item) => item.label === "Refundable");
    if (refundableItem) {
      return {
        id: "refundable",
        defaultMessage: "Refundable"
      };
    }
    const partiallyRefundableItem = policies.find(
      (item) => item.label === "Partially refundable"
    );
    if (partiallyRefundableItem) {
      return {
        id: "partially-refundable",
        defaultMessage: "Partially Refundable"
      };
    }
    return {
      id: "non-refundable",
      defaultMessage: "Non-Refundable"
    };
  };
  const { id, defaultMessage } = message();
  const intl = createIntl(
    {
      locale
    },
    intlCache
  );
  return {
    id,
    message: intl.formatMessage({
      id,
      defaultMessage
    })
  };
};
var isDateLocale = (locale) => {
  return !!locale && locale in Locales;
};
var safelyGetDateFnsLocale = (input) => {
  if (isDateLocale(input)) {
    return input;
  }
  const formattedLocale = input == null ? void 0 : input.replace("-", "");
  if (isDateLocale(formattedLocale)) {
    return formattedLocale;
  }
  const slicedLocale = input == null ? void 0 : input.slice(0, 2);
  if (isDateLocale(slicedLocale)) {
    return slicedLocale;
  }
  return "enGB";
};
var getDateFnsLocaleByLocaleString = (rawLocale) => {
  const supportedLocale = safelyGetDateFnsLocale(rawLocale);
  return Locales[supportedLocale];
};
var getListOfDatesFromInterval = ({
  startDate,
  endDate,
  locale
}) => {
  const dateLocale = getDateFnsLocaleByLocaleString(locale);
  if (startDate && endDate) {
    if (!isValid(new Date(startDate)) || !isValid(new Date(endDate)))
      return "";
    if (new Date(startDate).getTime() === new Date(endDate).getTime()) {
      return format(startDate, DATE_FORMAT, { locale: dateLocale });
    }
    return `From ${format(startDate, DATE_FORMAT, { locale: dateLocale })} to ${format(endDate, DATE_FORMAT, { locale: dateLocale })}`;
  }
  if (startDate && !endDate) {
    return format(startDate, DATE_FORMAT, { locale: dateLocale });
  }
  return "";
};

// src/hotels/formatting.ts
var intlCache2 = createIntlCache2();
var formatDateTime = (date, dateFormat, locale, shouldUseLocalTime) => {
  if (!date) {
    return void 0;
  }
  if (shouldUseLocalTime) {
    return format2(date.substring(0, 19), dateFormat, {
      locale: getDateFnsLocaleByLocaleString(locale)
    }) + " (Local time)";
  }
  const rawDate = parseISO(date);
  return format2(rawDate, dateFormat, {
    locale: getDateFnsLocaleByLocaleString(locale)
  });
};
var formatCopy = (params) => {
  const {
    rules,
    locale,
    templates,
    paragraphSeparator = DEFAULT_PARAGRAPH_SEPARATOR
  } = params;
  const intl = createIntl2(
    {
      locale,
      messages: templates
    },
    intlCache2
  );
  return rules.map((penalty) => {
    const _a = penalty, { id } = _a, variables = __objRest(_a, ["id"]);
    return {
      id,
      message: intl.formatMessage(
        {
          id
        },
        __spreadProps(__spreadValues({}, variables), { br: paragraphSeparator })
      )
    };
  });
};

// src/hotels/index.ts
var CANCELLATION_DATE_TIME_FORMAT = "do MMMM, h:mma";
var getHotelCancellationPolicy = ({
  packageRules,
  options,
  templates
}) => {
  const policies = getHotelPolicies(packageRules, options);
  const {
    locale,
    currency,
    dateFormat = CANCELLATION_DATE_TIME_FORMAT,
    paragraphSeparator
  } = options;
  const copy = formatCopy({
    currency,
    dateFormat,
    locale,
    rules: policies.flatMap((rule) => rule.penalties),
    templates,
    paragraphSeparator
  });
  return copy;
};

// src/carHires.ts
import { createIntl as createIntl3, createIntlCache as createIntlCache3 } from "@formatjs/intl";
var intlCache3 = createIntlCache3();
var getCarHireCancellationPolicy = ({ options, template }) => {
  const {
    locale,
    currency,
    paragraphSeparator = DEFAULT_PARAGRAPH_SEPARATOR
  } = options;
  const intl = createIntl3(
    {
      locale,
      messages: template
    },
    intlCache3
  );
  const messageId = "carHireDefault";
  const message = intl.formatMessage(
    {
      id: messageId
    },
    { userCurrency: currency, br: paragraphSeparator }
  );
  return message;
};

// src/flights.ts
import { createIntl as createIntl4, createIntlCache as createIntlCache4 } from "@formatjs/intl";
var intlCache4 = createIntlCache4();
var getFlightCancellationPolicy = ({ options, template }) => {
  const {
    locale,
    currency,
    paragraphSeparator = DEFAULT_PARAGRAPH_SEPARATOR
  } = options;
  const intl = createIntl4(
    {
      locale,
      messages: template
    },
    intlCache4
  );
  const messageId = "flightDefault";
  const message = intl.formatMessage(
    {
      id: messageId
    },
    { userCurrency: currency, br: paragraphSeparator }
  );
  return message;
};

// src/experiences.ts
import { createIntl as createIntl5, createIntlCache as createIntlCache5 } from "@formatjs/intl";
var intlCache5 = createIntlCache5();
var ruleToTemplateMapping = {
  cancelIfBadWeather: "experienceBadWeather",
  cancelIfInsufficientTravelers: "experienceInsufficientTravelers"
};
var DEFAULT_RULES = {
  cancelIfBadWeather: false,
  cancelIfInsufficientTravelers: false
};
var getExperienceCancellationPolicy = ({
  locale,
  rules = DEFAULT_RULES,
  templates,
  paragraphSeparator = DEFAULT_PARAGRAPH_SEPARATOR
}) => {
  const intl = createIntl5(
    {
      locale,
      messages: templates
    },
    intlCache5
  );
  const defaultId = "experienceDefault";
  const defaultMessage = intl.formatMessage({
    id: defaultId
  });
  const additionalMessages = Object.entries(rules).reduce(
    (acc, [key, value]) => {
      if (value) {
        const templateKey = ruleToTemplateMapping[key];
        acc.push(
          intl.formatMessage({ id: templateKey }, { br: paragraphSeparator })
        );
      }
      return acc;
    },
    []
  );
  const message = [defaultMessage, ...additionalMessages].join(
    paragraphSeparator
  );
  return message;
};
export {
  getCancellationTypeLabel,
  getCarHireCancellationPolicy,
  getExperienceCancellationPolicy,
  getFlightCancellationPolicy,
  getHotelCancellationPolicy,
  getIsRefundable
};
//# sourceMappingURL=index.mjs.map